import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, map, of } from 'rxjs';
import type { FeatureCollection, MultiPolygon } from 'geojson';
import { AppConfigService } from '../../services/app-config.service';
import { BoundaryDecoderService } from './boundary-decoder.service';

@Injectable({ providedIn: 'root' })
export class DistrictBoundaryLoaderService {
    private readonly http = inject(HttpClient);
    private readonly appConfigService = inject(AppConfigService);
    private readonly boundaryDecoder = inject(BoundaryDecoderService);

    private readonly cache = new Map<string, ArrayBuffer>();

    /**
     * Loads district admin boundaries for a city.
     * Path: `{AppGeographicBoundariesPath}/districts/{cityAccessKey}.bin`
     */
    loadDistrictBoundariesForCity(
        cityAccessKey: string,
    ): Observable<FeatureCollection<MultiPolygon>> {
        const path = this.appConfigService.geographicBoundariesPath?.replace(/\/+$/, '');
        const key = cityAccessKey?.trim();
        const empty = this.boundaryDecoder.mergeFeatureCollections([]);

        if (!path || !key) {
            return of(empty);
        }

        const cached = this.cache.get(key);
        const stream$ = cached
            ? of(cached)
            : this.http.get(`${path}/districts/${key}.bin`, { responseType: 'arraybuffer' });

        return stream$.pipe(
            map((buf) => {
                this.cache.set(key, buf);
                return this.boundaryDecoder.decodeDistrictBoundaries(key, buf);
            }),
            catchError((err) => {
                console.warn(`[DistrictBoundaryLoader] fetch failed for city ${key}`, err);
                return of(empty);
            }),
        );
    }
}
